<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6 21.5v-18h7c1.667 0 3.083.583 4.25 1.75C18.417 6.417 19 7.833 19 9.5c0 1.667-.583 3.083-1.75 4.25-1.167 1.167-2.583 1.75-4.25 1.75h-3v6H6Zm4-10h3.2c.55 0 1.02-.196 1.413-.588.391-.391.587-.862.587-1.412 0-.55-.196-1.02-.587-1.412A1.926 1.926 0 0 0 13.2 7.5H10v4Z"
    />
  </svg>
</template>
